export function lookupFormInfo(formName, versionId) {
  const formsInfo = JSON.parse(localStorage.getItem("formContainersVersions"));

  let f = formsInfo.find(
    (form) =>
      form.FormName.toLowerCase() === formName.split(":")[0].toLowerCase()
  );

  if (!f) {
    console.log("FORMS.JS - lookupFormInfo - form not found", formName);
    return;
  } else {
    const version = f.Versions.find(
      (v) => v.VersionId.toUpperCase() === versionId.toUpperCase()
    );

    if (!version) {
      console.log(
        "FORMS.JS - lookupFormInfo - form versionId not found",
        formName,
        versionId,
        f
      );
      return;
    }

    const setupConfiguration = version
      ? JSON.parse(version.SetupConfiguration)
      : {};

    let formVersionInfo = {
      formId: f.FormId,
      formName:
        setupConfiguration.type === "Formsy"
          ? setupConfiguration.portalFormName
          : setupConfiguration.type === "Docusign"
          ? setupConfiguration.form[0].FormDescription
          : f.FormDescription,
      formDescription: f.FormDescription,
      formPath: setupConfiguration.formPath,
      formVersionId: version.VersionId,
      formVersionNumber: version.VersionIntId.toString(),
      reportFieldNames: setupConfiguration.reportFieldNames,
      formType: setupConfiguration.type,
      setupConfiguration: setupConfiguration,
      formData: f,
    };
    if (setupConfiguration.extraFields) {
      formVersionInfo.extraFields = setupConfiguration.extraFields;
    }
    if (setupConfiguration.reportFieldNames) {
      formVersionInfo.reportFieldNames = setupConfiguration.reportFieldNames;
    }

    return formVersionInfo;
  }
}
export function lookupFormInfov2(formsInfo, formName, versionId) {
  let f = formsInfo.find(
    (form) =>
      form.FormName.toLowerCase() === formName.split(":")[0].toLowerCase()
  );

  if (!f) {
    console.log("FORMS.JS - lookupFormInfo - form not found", formName);
    return;
  } else {
    const version = f.Versions.find(
      (v) => v.VersionId.toUpperCase() === versionId.toUpperCase()
    );

    if (!version) {
      console.log(
        "FORMS.JS - lookupFormInfo - form versionId not found",
        formName,
        versionId,
        f
      );
      return;
    }

    const setupConfiguration = version
      ? JSON.parse(version.SetupConfiguration)
      : {};

    let formVersionInfo = {
      formId: f.FormId,
      formName:
        setupConfiguration.type === "Formsy"
          ? setupConfiguration.portalFormName
          : setupConfiguration.type === "Docusign"
          ? setupConfiguration.form[0].FormDescription
          : f.FormDescription,
      formDescription: f.FormDescription,
      formPath: setupConfiguration.formPath,
      formVersionId: version.VersionId,
      formVersionNumber: version.VersionIntId.toString(),
      reportFieldNames: setupConfiguration.reportFieldNames,
      formType: setupConfiguration.type,
      setupConfiguration: setupConfiguration,
      formData: f,
    };
    if (setupConfiguration.extraFields) {
      formVersionInfo.extraFields = setupConfiguration.extraFields;
    }
    if (setupConfiguration.reportFieldNames) {
      formVersionInfo.reportFieldNames = setupConfiguration.reportFieldNames;
    }

    return formVersionInfo;
  }
}

export function lookupHighestVersion(formName) {
  const formInfo = getFormList(formName);
  if (!formInfo) {
    console.log("FORMS.JS - lookupFormInfo - form not found", formName);
    return;
  }

  return formInfo;
}

export function getFormList(item) {
  const formsInfo = JSON.parse(localStorage.getItem("formContainersVersions"));
  const formName = item.split(":")[0];
  let formObject = {};
  let f = formsInfo.find(
    (form) => form.FormName.toLowerCase() === formName.toLowerCase()
  );
  if (f) {
    const version = f.Versions.find((v) => {
      if (!v.Active) return false;

      if (
        v.InDevelopment &&
        process.env.REACT_APP_ENVIRONMENT !== "Development"
      )
        return false;

      return true;
    });

    if (!version) {
      return {};
    }

    const setupConfiguration = version
      ? JSON.parse(version.SetupConfiguration)
      : {};

    formObject = {
      formId: f.FormId,
      formName:
        setupConfiguration.type === "Formsy"
          ? setupConfiguration.portalFormName
          : setupConfiguration.type === "Docusign"
          ? setupConfiguration.form[0].FormDescription
          : f.FormDescription,
      formDescription: f.FormDescription,
      formPath: setupConfiguration.formPath,
      formVersionId: version.VersionId,
      formVersionNumber: version.VersionIntId.toString(),
      reportFieldNames: setupConfiguration.reportFieldNames,
      formType: setupConfiguration.type,
      setupConfiguration: setupConfiguration,
      formData: f,
    };
    if (setupConfiguration.extraFields) {
      formObject.extraFields = setupConfiguration.extraFields;
    }
    if (setupConfiguration.reportFieldNames) {
      formObject.reportFieldNames = setupConfiguration.reportFieldNames;
    }
  } else {
    if (formName.includes("v")) {
      var regex = /[v]\d/;
      let match = regex.exec(formName.toLowerCase());
      //console.log("Checking Form Version and RegEx Match", formName, match);
      if (match?.index) {
        const coreForm = formName.toLowerCase().substring(0, match.index);
        f = formsInfo.find((form) => form.FormName.toLowerCase() === coreForm);
        if (f) {
          const specificVersion = f.Versions.find(
            (v) =>
              v.VersionIntId.toString() ===
              formName.toLowerCase().substring(match.index + 1)
          );
          const specificSetupConfiguration = JSON.parse(
            specificVersion.SetupConfiguration
          );
          formObject = {
            formId: f.FormId,
            formName: specificSetupConfiguration.portalFormName,
            formDescription: specificSetupConfiguration.formDescription,
            formPath: specificSetupConfiguration.formPath,
            formVersionId: specificVersion.VersionId,
            formVersionNumber: specificVersion.VersionIntId.toString(),
            formType: specificSetupConfiguration.type,
            setupConfiguration: specificSetupConfiguration,
            formData: f,
          };
          if (specificSetupConfiguration.extraFields) {
            formObject.extraFields = specificSetupConfiguration.extraFields;
          }
          if (specificSetupConfiguration.reportFieldNames) {
            formObject.reportFieldNames =
              specificSetupConfiguration.reportFieldNames;
          }
        } else {
          console.log("Form or Form Version not found", formName);
          return {};
        }
      }
    } else {
      console.log("Form not found", formName);
      return {};
    }
  }
  return formObject;
}

export function getFormListv2(formsInfo, item) {
  const formName = item.split(":")[0];
  let formObject = {};
  let f = formsInfo.find(
    (form) => form.FormName.toLowerCase() === formName.toLowerCase()
  );
  if (f) {
    const version = f.Versions.find((v) => {
      if (!v.Active) return false;

      if (
        v.InDevelopment &&
        process.env.REACT_APP_ENVIRONMENT !== "Development"
      )
        return false;

      return true;
    });

    if (!version) {
      return {};
    }

    const setupConfiguration = version
      ? JSON.parse(version.SetupConfiguration)
      : {};

    formObject = {
      formId: f.FormId,
      formName:
        setupConfiguration.type === "Formsy"
          ? setupConfiguration.portalFormName
          : setupConfiguration.type === "Docusign"
          ? setupConfiguration.form[0].FormDescription
          : f.FormDescription,
      formDescription: f.FormDescription,
      formPath: setupConfiguration.formPath,
      formVersionId: version.VersionId,
      formVersionNumber: version.VersionIntId.toString(),
      reportFieldNames: setupConfiguration.reportFieldNames,
      formType: setupConfiguration.type,
      setupConfiguration: setupConfiguration,
      formData: f,
    };
    if (setupConfiguration.extraFields) {
      formObject.extraFields = setupConfiguration.extraFields;
    }
    if (setupConfiguration.reportFieldNames) {
      formObject.reportFieldNames = setupConfiguration.reportFieldNames;
    }
  } else {
    if (formName.includes("v")) {
      var regex = /[v]\d/;
      let match = regex.exec(formName.toLowerCase());
      //console.log("Checking Form Version and RegEx Match", formName, match);
      if (match?.index) {
        const coreForm = formName.toLowerCase().substring(0, match.index);
        f = formsInfo.find((form) => form.FormName.toLowerCase() === coreForm);
        if (f) {
          const specificVersion = f.Versions.find(
            (v) =>
              v.VersionIntId.toString() ===
              formName.toLowerCase().substring(match.index + 1)
          );
          const specificSetupConfiguration = JSON.parse(
            specificVersion.SetupConfiguration
          );
          formObject = {
            formId: f.FormId,
            formName: specificSetupConfiguration.portalFormName,
            formDescription: specificSetupConfiguration.formDescription,
            formPath: specificSetupConfiguration.formPath,
            formVersionId: specificVersion.VersionId,
            formVersionNumber: specificVersion.VersionIntId.toString(),
            formType: specificSetupConfiguration.type,
            setupConfiguration: specificSetupConfiguration,
            formData: f,
          };
          if (specificSetupConfiguration.extraFields) {
            formObject.extraFields = specificSetupConfiguration.extraFields;
          }
          if (specificSetupConfiguration.reportFieldNames) {
            formObject.reportFieldNames =
              specificSetupConfiguration.reportFieldNames;
          }
        } else {
          console.log("Form or Form Version not found", formName);
          return {};
        }
      }
    } else {
      console.log("Form not found", formName);
      return {};
    }
  }
  return formObject;
}
